module.exports = __webpack_public_path__ + "static/korobeinikiHandinHandMoment-ac6a6cb10da762f475117b1428bb919c.mp3";